import { Star } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";
import { useAuth } from "@/context/AuthContext";

/**
 * Stella "preferito" privata per utente. Si mostra solo se loggato.
 * Riutilizzabile su qualsiasi listato giocatori (Giocatori, Mercato, Svincolati).
 */
export function FavoriteStar({ pesId, size = 18, className = "" }) {
    const { user } = useAuth();
    const { isFavorite, toggle } = useFavorites();
    if (!user || pesId == null) return null;
    const active = isFavorite(pesId);
    return (
        <button
            type="button"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggle(pesId);
            }}
            title={active ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
            aria-pressed={active}
            className={`shrink-0 transition-colors drop-shadow ${
                active ? "text-te8ff00" : "text-tc9ccd3 hover:text-te8ff00"
            } ${className}`}
            data-testid={`favorite-star-${pesId}`}
        >
            <Star size={size} fill={active ? "rgb(var(--tc-e8ff00))" : "none"} strokeWidth={2} />
        </button>
    );
}
